export default function handleError(error) {
    if (error?.response) {
        var data = error.response.data;    
        switch (error.response.status) {
            case 403: return "Você não possui acesso a este recurso";
            case 402: return data?.message ? data.message : "Licença expirada. Por favor entre em contato com o administrador.";
            case 400: return data?.message ? data.message : "Erro. Por favor revise os dados e tente novamente";            
            default: return data?.message ? data.message : "Erro desconhecido. Tente novamente mais tarde."
        }        
    }

    return error;
}